import { apiFetch } from "./client";

export interface AssistantMessage {
  id: string;
  role: "user" | "assistant";
  content: string;
  metadata?: {
    toolSteps?: Array<{ id: string; name: string; status: string; durationMs?: number }>;
    guideOffers?: Array<{ guideId: string; title: string }>;
  } | null;
  createdAt: string;
}

export interface AssistantSessionResponse {
  session: { id: string; title: string };
  messages: AssistantMessage[];
  assistantName?: string;
}

/** Page context the widget reports so Scout can auto-scope "this agent/workflow". */
export interface AssistantPageContext {
  path?: string;
  agentId?: string;
  workflowId?: string;
  runId?: string;
}

/** One row of the Scout history picker. */
export interface AssistantSessionSummary {
  id: string;
  title: string;
  updatedAt: string;
  messageCount: number;
  /** The user's first message, used as the label. */
  preview: string | null;
}

export const assistantApi = {
  /** `sessionId` reopens a past conversation from the history picker. */
  getSession: (companyId: string, sessionId?: string) =>
    apiFetch<AssistantSessionResponse>(
      `/companies/${companyId}/assistant/session${
        sessionId ? `?sessionId=${encodeURIComponent(sessionId)}` : ""
      }`,
    ),
  listSessions: (companyId: string) =>
    apiFetch<{ sessions: AssistantSessionSummary[] }>(
      `/companies/${companyId}/assistant/sessions`,
    ),
  resetSession: (companyId: string) =>
    apiFetch<AssistantSessionResponse>(`/companies/${companyId}/assistant/session/reset`, {
      method: "POST",
    }),
};
